import React, { Component, createRef } from "react";
import DataTable from './TableBase';
import { IconButton } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { apiCall, getEmployes } from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class UsersTable extends Component {

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    setEmployees = async () => {
        const employees = await getEmployes();
        localStorage.setItem('employees', JSON.stringify(employees));
    }
    handleDelete = async (userId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/user/delete/' + userId, 'delete', null);
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Kullanıcı başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    handleUserDetail = (userId) => {
        this.props.history.push(`/user-detail/${userId}`);
    }
    render() {
        const { pending } = this.state;
        const { userPermissions } = this.props;
        const userHasViewUserPermission = userPermissions.includes('view user');
        const userHasDeleteUserPermission = userPermissions.includes('delete user');

        const columns = [
            {
                name: 'ID',
                selector: row => row.id,
                sortable: true
            },
            {
                name: 'İsim',
                selector: row => row.name,
                sortable: true
            },
            {
                name: 'Soyisim',
                selector: row => row.surname
            },
            {
                name: 'E-mail',
                selector: row => row.email
            },
            {
                name: 'Rol',
                selector: row => row.roles[0] && row.roles[0].name.split('_')[0],
            },
            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>

                        {userHasDeleteUserPermission ? (
                            <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{ cursor: 'pointer', marginLeft: -15 }}>
                                <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                            </IconButton>
                        ) : ""}

                    </>
                )
            }

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/user/all"}
                columns={columns}
                onRowClicked={userHasViewUserPermission ? row => this.handleUserDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(UsersTable));
